import React from 'react';
import {MasterLayout} from 'layout';
import {BoSungThongTin} from "modules/bo-sung-thong-tin";

class BoSungThongTinLanhDaoPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <BoSungThongTin params={this.props.params} lanhDao={true}/>
      </MasterLayout>
    );
  }
}

export default BoSungThongTinLanhDaoPage;


// WEBPACK FOOTER //
// ./src/components/pages/bo-sung-thong-tin/BoSungThongTinLanhDaoPage.jsx